import { render, staticRenderFns } from "./importCollaborator.vue?vue&type=template&id=7cb15b68"
import script from "./importCollaborator.vue?vue&type=script&lang=js"
export * from "./importCollaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports